// 第6张
const imgAll6 = {
    JP: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724642304381/a6.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724642844490/c6.jpg',
    },
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725415008321/Frame%201000008645%20(2)%20(1).jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724642844490/c6.jpg',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725092257490/a6.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725092747951/b6.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725093142328/uk6.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725093605555/uk6.jpg',
    },
};
export const imgLocale6: any = {
    jp: imgAll6.JP,
    us: imgAll6.NA,
    ca: imgAll6.NA,
    uk: imgAll6.UK,
    br: imgAll6.NA,
    mx: imgAll6.NA,
    eu: imgAll6.EU,
    de: imgAll6.EU,
    fr: imgAll6.EU,
    it: imgAll6.EU,
    es: imgAll6.EU,
    nl: imgAll6.EU,
};
